import { Injectable } from "@angular/core"
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { MatSnackBar } from "@angular/material/snack-bar"
import { exhaustMap, map } from 'rxjs'
import { MessageService } from "primeng/api";
import { emptyaction, hideWarning, showalert, showWarning } from "../actions/warning.action";

@Injectable()
export class WarningEffects {
    constructor(private $action: Actions, private _snackbar: MatSnackBar,private messageService: MessageService) {}

    _showalert = createEffect(() =>
        this.$action.pipe(
            ofType(showalert),
            exhaustMap((action) => {
                 this.messageService.add({severity: action.severity, summary: action.summary, detail: action.detail}); // Show success toast
                return [emptyaction()];
            })
        )
    );

    showWarning$ = createEffect(() =>
        this.$action.pipe(
          ofType(showWarning),
          map(() => {
            this.messageService.add({ key: 'confirm', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed' });
          })
        ),
        { dispatch: false }
      );


      hideWarning$ = createEffect(() =>
        this.$action.pipe(
          ofType(hideWarning),
          map(() => {
            // You can add additional logic here
            this.messageService.clear('confirm');
          })
        ),
        { dispatch: false }
      );
}